module.exports = __webpack_public_path__ + "img/16.b6897a8e.jpg";